import React from 'react'
// see https://www.npmjs.com/package/sanitize-html for options
import sanitizeHtml from 'sanitize-html'

import '@/styles/docebo-markup.css'
import { cn } from '@/lib/utils'

const ALLOWED_TAGS = [
  'address',
  'article',
  'aside',
  'footer',
  'header',
  'h1',
  'h2',
  'h3',
  'h4',
  'h5',
  'h6',
  'hgroup',
  'main',
  'nav',
  'section',
  'blockquote',
  'dd',
  'div',
  'dl',
  'dt',
  'figcaption',
  'figure',
  'hr',
  'li',
  'main',
  'ol',
  'p',
  'pre',
  'ul',
  'a',
  'abbr',
  'b',
  'bdi',
  'bdo',
  'br',
  'cite',
  'code',
  'data',
  'dfn',
  'em',
  'i',
  'kbd',
  'mark',
  'q',
  'rb',
  'rp',
  'rt',
  'rtc',
  'ruby',
  's',
  'samp',
  'small',
  'span',
  'strong',
  'sub',
  'sup',
  'time',
  'u',
  'var',
  'wbr',
  'caption',
  'col',
  'colgroup',
  'table',
  'tbody',
  'td',
  'tfoot',
  'th',
  'thead',
  'tr',
]

function CourseDescription({
  descriptionHtml,
  className,
}: {
  descriptionHtml: string
  className: string
}) {
  const markup = {
    __html: sanitizeHtml(descriptionHtml, {
      // disallowedTagsMode: 'completelyDiscard',
      allowedTags: ALLOWED_TAGS,
    }),
  }

  return (
    <div
      className={cn('docebo-markup', className)}
      dangerouslySetInnerHTML={markup}
    />
  )
}

export default CourseDescription
